import LogoOrBackLink from "./parts/LogoOrBackLink";
import NavWrapper from "./NavWrapper";
import UserMenu from "./UserMenu/UserMenu";
import LogoLink from "./parts/LogoLink";

export default function Nav() {
  return (
    <NavWrapper>
      <LogoOrBackLink>
        <LogoLink />
      </LogoOrBackLink>
      <UserMenu />
    </NavWrapper>
  );
}
